const initialState = {
  same_as_company_address: true,
  secondary_insurance_address: false,
  selected_invoice_address: 1,
  authorized_representative: false,
  contact_regarding_insurances: "",
  contact_information: {
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    social_security_number: "",
    street_address: "",
    zip_code: "",
    mailing_address: "",
    municipality: "",
    current_street_address: "",
    current_zip_code: "",
    current_mailing_address: ""
  },
  apartment_information: {
    landlord: "",
    number_of_rooms: "",
    security_door: false,
    insurance_start: "",
    social_security_number: "",
    street_address: "",
    zip_code: "",
    mailing_address: "",
    municipality: "",
    current_street_address: "",
    current_zip_code: "",
    current_mailing_address: "",
    supplementary_insurance: {
      comprehensive_insurance: "",
      increased_travel_protection: "",
      personal_accident_insurance: "",
      tenant_insurance: ""
    },
    personal_accident_insurances: [
      {
        name: "",
        ssn: ""
      },
      {
        name: "",
        ssn: ""
      },
      {
        name: "",
        ssn: ""
      },
      {
        name: "",
        ssn: ""
      },
      {
        name: "",
        ssn: ""
      },
      {
        name: "",
        ssn: ""
      }
    ],
    payment_method: [
      {
        name: "Autogiro - Helårsvis"
      },
      {
        name: "Autogiro - Halvårsvis (3% avgift tillkommer)"
      },
      {
        name: "Autogiro - Månadsvis (3% avgift tillkommer)"
      },
      {
        name: "Bankgiro - Helår"
      },
      {
        name: "Bankgiro - Halvår (3% avgift tillkommer)"
      }
    ],
    other_information: "",
    contact_me: false,
    contact_me_area: [
      {
        name: "Bilförsäkring",
      },
      {
        name: "Bank",
      },
      {
        name: "Olycksfallsförsäkring",
      },
      {
        name: "Förebygga skada",
      },
      {
        name: "Övriga frågor",
      },
    ],
    want_information_on: ""
  },
  company_information: {
    company_name: "",
    organization_number: "",
    street_address: "",
    zip_code: "",
    city: ""
  },
  insurance_information: {
    same_as_company_address: true,
    selected_invoice_address: 1,
    invoice_address: {
      address: "",
      zip_code: "",
      city: ""
    },
    second_address: {
      address: "",
      zip_code: "",
      city: ""
    },
    other_address: {
      address: "",
      zip_code: "",
      city: ""
    }
  },
  payment_information: {
    insurance_starts_at: "",
    payment_interval: "",
    invoice_address: {
      address: "",
      zip_code: "",
      city: ""
    }
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ADD_INSURANCE_ADDRESS_SUCCESS": {
      return {
        ...state,
        secondary_insurance_address: true
      };
    }

    case "UPDATE_INSURANCE_ADDRESS_SUCCESS":
      return {
        ...state,
        insurance_information: Object.assign({}, state.insurance_information, {
          other_address: action.payload
        })
      };
    case "UPDATE_SECOND_INSURANCE_ADDRESS_SUCCESS":
      return {
        ...state,
        insurance_information: Object.assign(
          {},
          state.insurance_information,
          action.payload
        )
      };
    case "UPDATE_INVOICE_ADDRESS_SUCCESS":
      return {
        ...state,
        insurance_information: Object.assign({}, state.insurance_information, {
          invoice_address: action.payload
        })
      };

    case "REMOVE_INSURANCE_ADDRESS_SUCCESS": {
      return {
        ...state,
        secondary_insurance_address: false
      };
    }
    case "SET_CONTACT_DATA_SUCCESS":
      return {
        ...state,
        contact_information: Object.assign(
          {},
          state.contact_information,
          action.payload
        )
      };
    case "SET_COMPANY_DATA_SUCCESS":
      return {
        ...state,
        contact_information: Object.assign(
          {},
          state.company_information,
          action.payload
        )
      };
    case "SET_PAYMENT_DATA_SUCCESS":
      return {
        ...state,
        contact_information: Object.assign(
          {},
          state.payment_information,
          action.payload
        )
      };
    case "SET_INSURANCE_ADDRESS_SAME_AS_ADDRESS":
      return {
        ...state,
        contact_information: Object.assign(
          {},
          state.payment_information,
          action.payload
        )
      };
    case "SET_SUMMARY_CONTACT_INFORMATION_SUCCESS":
      return {
        ...state,
        contact_information: Object.assign(
          {},
          state.contact_information,
          action.payload
        )
      };
    case "SET_SUMMARY_COMPANY_INFORMATION_SUCCESS":
      return {
        ...state,
        company_information: Object.assign(
          {},
          state.company_information,
          action.payload
        )
      };
    case "SET_SUMMARY_INSURANCE_INFORMATION_SUCCESS":
      return {
        ...state,
        insurance_information: Object.assign(
          {},
          state.insurance_information,
          action.payload
        )
      };

    case "SET_SUMMARY_PAYMENT_INFORMATION_SUCCESS":
      return {
        ...state,
        payment_information: Object.assign(
          {},
          state.payment_information,
          action.payload
        )
      };

    case "SET_CONFIRMATION_DATA_SUCCESS": {
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};
